import { IUser } from './IUser';
import { UserCategory } from './UserCategory';

/** Admin profile (permission role) for this site user, when present. Returned with getSiteUsers. */
export interface ISiteUserAdminProfile {
  luid: string;
  name: string;
  description?: string;
}

export interface ISiteUser extends IUser {
  groupCount?: number;
  lastSignIn?: string; // not present if user hasn't signed into site before.
  siteRole: string;
  authenticationProviderId?: string; // not present unless server.isSiteSamlEnabled
  authSetting?: string; // (deprecated in favor of authenticationProviderId)
  notificationEnabled?: boolean;
  userImageUrl?: string; // not present if a user image doesn't exist for this site user
  idpConfigurationName?: string;
  idpConfigurationId?: string;
  emailAddress?: string;
  /** Admin profile assigned to this user on the site (prepopulated from getSiteUsers). */
  adminProfile?: ISiteUserAdminProfile;
  userCategory?: UserCategory;
}

export let SiteUserAuthSetting = {
  Oidc: 'OIDC',
  Saml: 'SAML',
  Default: 'DEFAULT',
  TabId_with_MFA: 'TABID_WITH_MFA'
};
